<template>
  <div
    :class="$style.wrapper"
    class="d-flex justify-content-center flex-wrap align-items-center"
  >
    <slot v-bind="{ itemClass: $style.item }" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
});
</script>

<style lang="scss" module>
@import '~@/scripts/pages/onepager/styles/variables-entry';

.item {
  padding: 3.15rem;
  padding: Min(7vw, 3.15rem);
  max-width: 16rem;
  max-width: Min(calc(50vw), 16rem);
}
</style>
